import { UNIT } from '../../../constant/unit'
import { defineMessages } from 'react-intl'

const labels = defineMessages({
  imperial: {
    id: 'WeightUnit.imperial',
    defaultMessage: 'lbs',
    description: 'The label used for the imperial weight unit.'
  },
  metric: {
    id: 'WeightUnit.metric',
    defaultMessage: 'kgs',
    description: 'The label used for the metric weight unit.'
  }
})

const labelsWithValue = defineMessages({
  imperial: {
    id: 'WeightUnit.imperialWithValue',
    defaultMessage: '{value} lbs',
    description: 'The label used for the imperial weight unit.'
  },
  metric: {
    id: 'WeightUnit.metricWithValue',
    defaultMessage: '{value} kgs',
    description: 'The label used for the metric weight unit.'
  }
})

const WEIGHT_UNIT_MESSAGE = {
  [UNIT.IMPERIAL]: labels.imperial,
  [UNIT.METRIC]: labels.metric
}

const WEIGHT_UNIT_MESSAGE_US_EN = {
  [UNIT.IMPERIAL]: 'lbs',
  [UNIT.METRIC]: 'kgs'
}

const WEIGHT_UNIT_MESSAGE_WITH_VALUE = {
  [UNIT.IMPERIAL]: labelsWithValue.imperial,
  [UNIT.METRIC]: labelsWithValue.metric
}

const WEIGHT_UNIT_KG_PER_LB = 0.453592

export {
  WEIGHT_UNIT_MESSAGE,
  WEIGHT_UNIT_MESSAGE_US_EN,
  WEIGHT_UNIT_MESSAGE_WITH_VALUE,
  WEIGHT_UNIT_KG_PER_LB
}
